import * as React from 'react';
import {Field, FieldProps} from 'formik';
import {withTranslation, WithTranslation} from 'react-i18next';

import ValidationError from '@src/components/Form/ValidationError';

import * as styles from './textInput.module.scss';

import type {Namespace} from 'i18next';

export interface TextInputProps extends WithTranslation<'EnrollForm'> {
  name: string;
  label?: string;
  required: boolean;
  description?: string;
  type?: string;
  title?: string;
  inlineWidth?: 'formColHalf' | 'formColThird';
  inverse?: boolean;
  hideError?: boolean;
  ignoreTranslations?: boolean;
}

export const UntranslatedTextInput = ({
  name,
  label,
  required,
  description,
  type,
  title,
  inlineWidth,
  inverse,
  hideError,
  t,
  ignoreTranslations,
}: TextInputProps) => {
  const textInput = (
    <div
      className={`${inverse ? styles.inverse : ''} ${
        inlineWidth ? styles[inlineWidth] : styles.inputColFull
      }`}>
      <label htmlFor={name}>
        {/* @ts-ignore */}
        {ignoreTranslations ? label : t(name)}{' '}
        {required && <span className={styles.required}>{t('required')}</span>}
      </label>
      {description && <p className={styles.description}>{description}</p>}
      <Field name={name}>
        {({field, form: {touched, errors}}: FieldProps) => (
          <input
            {...field}
            id={field.name}
            type={type ? type : 'text'}
            title={title}
            className={`${styles.input} ${
              touched[field.name] && errors[field.name] && styles.hasError
            }`}
          />
        )}
      </Field>
      {!hideError && <ValidationError name={name} inverse={inverse} />}
    </div>
  );

  return inlineWidth ? (
    textInput
  ) : (
    <div className={styles.formGroup}>{textInput}</div>
  );
};

export default withTranslation('EnrollForm')(UntranslatedTextInput);

export const translateTextInput = (translationFile: Namespace) =>
  withTranslation(translationFile)(UntranslatedTextInput);
